/* eslint-disable import/prefer-default-export */
export function mapWidgets(fields) {
  return Object.assign({}, ...fields.map(
    item => ({
      [item.key]: {
        get() {
          if (item.path === '') {
            return this.$store.getters[`widget${this.id}/getItem`][item.key];
          }

          return this.$store.getters[`widget${this.id}/getItem`][item.path][item.key];
        },
      },
    }),
  ));
}
